import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SelectItem } from 'primeng/api';
import { catchError, map, of } from 'rxjs';
import { SERVICE_ENDPOINTS } from '../../core/configs/service-endpoints';
import { ErrorCode } from '../../core/enums/error-code';
import { AuthService } from '../../core/services/auth.service';
import { ErrorProviderService } from '../../core/services/error-provider.service';
import { OrganisationData } from '../interfaces/organisation/organisation-data';
import { CustomerDataService } from '../services/customer-data.service';

export const referralPartnerListResolver: ResolveFn<SelectItem[]> = (route, state) => {

  const auth = inject(AuthService);
  const customerDataService = inject(CustomerDataService);
  const errorProvider = inject(ErrorProviderService);

  /**
   * on browser refresh token is not ready
   */
  if (!auth.hasValidToken) {
    return of([]);
  } else {
    return customerDataService.findAll(SERVICE_ENDPOINTS.GET_ORGANISATIONS_REFERRAL_PARTNER).pipe(
      map((serviceResponse) => {
        errorProvider.resetError();
        if (!serviceResponse.successful) {
          errorProvider.errorCode = ErrorCode.REFERRAL_PARTNER_LIST;
          errorProvider.errorMessage = serviceResponse.message;
          errorProvider.errorDetails = serviceResponse.details;
          return [];
        }
        return serviceResponse.payload.map((organisation: OrganisationData) => ({
          label: organisation.name,
          value: organisation.id,
        }));
      }),
      catchError(err => {
        errorProvider.resetError();
        console.error('Referral-Partner-List Resolver error: ', err);
        errorProvider.errorCode = ErrorCode.REFERRAL_PARTNER_LIST;
        errorProvider.errorMessage = err.message;
        errorProvider.errorDetails = '';
        return of([]);
      })
    )
  }
};
